export * from './view'
export * from './add'
export * from './edit'
export * from './details'

